import { EDamageSeverity } from "@inbound/api";
import { Button, css, styled } from "@lux/ds";

export const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== "$severityLevel",
})<{
  $severityLevel: EDamageSeverity | null;
}>(
  ({ $severityLevel, theme }) => css`
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 180px;
    min-height: 48px;
    padding: 6px ${theme.space.xs};
    border-radius: ${theme.space.xs};
    background-color: ${theme.palette.common.white};

    .damageTicker-decreaseButton,
    .damageTicker-increaseButton {
      &:hover {
        background-color: unset !important;
      }
    }

    ${$severityLevel === EDamageSeverity.Low
      ? css`
          background-color: ${theme.palette.primary.shade[60]} !important;

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton {
            &:hover {
              background-color: ${theme.palette.primary.shade[40]} !important;
            }
          }

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton,
          .damageTicker-label,
          .damageTicker-value {
            color: ${theme.palette.common.white} !important;
          }
        `
      : ""};

    ${$severityLevel === EDamageSeverity.Medium
      ? css`
          background-color: ${theme.palette.primary.shade[40]} !important;

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton {
            &:hover {
              background-color: ${theme.palette.primary.shade[20]} !important;
            }
          }

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton,
          .damageTicker-label,
          .damageTicker-value {
            color: ${theme.palette.common.white} !important;
          }
        `
      : ""};

    ${$severityLevel === EDamageSeverity.High
      ? css`
          background-color: ${theme.palette.primary.shade[20]} !important;

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton {
            &:hover {
              background-color: ${theme.palette.primary.shade[20]} !important;
            }
          }

          .damageTicker-decreaseButton,
          .damageTicker-increaseButton,
          .damageTicker-label,
          .damageTicker-value {
            color: ${theme.palette.common.white} !important;
          }
        `
      : ""};
  `,
);
